import React, { Suspense } from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from "react-router-dom";

import { NavigationBar } from "components/LayoutComponents";
import { ErrorBoundary } from "components/ErrorBoundary";

import { Breadcrumbs } from "../Breadcrumbs";
import { MainContent } from "./components/MainContent";
import { ProfileMenu } from "./components/ProfileMenu";

const UserProfile = React.lazy(() => import("../UserProfile"));
const ActualUserAppointments = React.lazy(
  () => import("../ActualUserAppointments")
);
const ExpiredUserAppointments = React.lazy(
  () => import("../ExpiredUserAppointments")
);
const UserAppointmentDetails = React.lazy(
  () => import("../UserAppointmentDetails")
);
const UserEditAppointment = React.lazy(() => import("../UserEditAppointment"));
const UserExpiredAppointmentDetails = React.lazy(
  () => import("../UserExpiredAppointmentDetails")
);

const ProtectedRoutes = () => {
  const match = useRouteMatch();
  const { pathname } = useLocation();
  return (
    <>
      <NavigationBar>
        <ProfileMenu />
      </NavigationBar>
      <Flex flex={1} direction="column">
        <MainContent>
          <ErrorBoundary resetKeys={[pathname]}>
            <Suspense fallback={<Spinner size="xl" />}>
              <Breadcrumbs />
              <Switch>
                <Route
                  exact
                  path={`${match.path}/`}
                  render={() => <Redirect to={`${match.path}/profil`} />}
                />
                <Route
                  exact
                  path={`${match.path}/profil`}
                  component={UserProfile}
                />
                <Route
                  exact
                  path={`${match.path}/aktualne-wizyty`}
                  component={ActualUserAppointments}
                />
                <Route
                  exact
                  path={`${match.path}/historyczne-wizyty`}
                  component={ExpiredUserAppointments}
                />
                <Route
                  exact
                  path={`${match.path}/aktualne-wizyty/:appointmentId`}
                  component={UserAppointmentDetails}
                />
                <Route
                  exact
                  path={`${match.path}/historyczne-wizyty/:appointmentId`}
                  component={UserExpiredAppointmentDetails}
                />
                <Route
                  exact
                  path={`${match.path}/aktualne-wizyty/:appointmentId/edycja`}
                  component={UserEditAppointment}
                />
              </Switch>
            </Suspense>
          </ErrorBoundary>
        </MainContent>
      </Flex>
    </>
  );
};

export { ProtectedRoutes };
